import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import React, { useEffect, useState } from 'react';
import useStoresFilter from '../../../../hooks/utils/useStoresFilter.js';
import FiltersDrawer from '../DashboardOrderFilter.jsx';

export const FilterComponent = ({ formData, setFormData, orderType }) => {
  const [orderByIndex, setOrderByIndex] = useState(0);
  const [filters, setFilters] = useState(orderType.filters || []);
  const { getStoresByFilter } = useStoresFilter();

  const updateFilter = async (filterName, item) => {
    const value = item?.code || item?.name;
    const updatedFilters = filters?.map((filter) => {
      if (filter.label === filterName) {
        const checkedItems = filter.checkedItems?.includes(value)
          ? filter.checkedItems.filter((f) => f !== value)
          : [...filter.checkedItems, value];
        return { ...filter, checkedItems };
      } else {
        return filter;
      }
    });
    if (filterName === 'Marques' && value) {
      // Quand le filtre de marques change, le filtres des stores s'adapte
      const brandFilter = updatedFilters?.find(
        ({ label }) => label === 'Marques'
      );
      const res = await getStoresByFilter({
        brands: brandFilter?.checkedItems,
      });
      const storesList = res?.map((item) => item?.name);
      updatedFilters?.map((filter) => {
        if (filter?.label === 'Magasins') {
          filter.defaultList = storesList || [];
        }
      });
    }
    setFilters(updatedFilters);
  };

  const clearFilter = (filterName) => {
    const updatedFilters = filters?.map((filter) => {
      if (filter.label === filterName) {
        return { ...filter, checkedItems: [] };
      } else {
        return filter;
      }
    });
    setFilters(updatedFilters);
  };

  useEffect(() => {
    setFormData((state) => ({
      ...state,
      orderBy: orderType.sortOptions[orderByIndex].value,
      orderByIndex: orderByIndex,
      filters: filters,
    }));
  }, [orderByIndex, filters, orderType]);

  useEffect(() => {
    setFilters(orderType?.filters || []);
    setOrderByIndex(0);
  }, [orderType]);

  return (
    <Box sx={{ display: 'flex', gap: 3, width: '40%' }}>
      <FormControl sx={{ width: '50%' }}>
        <InputLabel id="sort-by-label">Trier par</InputLabel>
        <Select
          labelId="sort-by-label"
          id="sort-by-select"
          label="Trier par"
          value={orderByIndex}
          onChange={(e) => {
            setOrderByIndex(e.target.value);
          }}
        >
          {orderType.sortOptions.map((option, index) => (
            <MenuItem key={index} value={index}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FiltersDrawer
        updateFilter={updateFilter}
        clearFilter={clearFilter}
        filters={filters}
      />
    </Box>
  );
};
